import { Form } from "antd";
import Select from "components/BaseWidgets/select";
import {
  drinking,
  selectBodyHeight,
  selectBodyWeight,
  smoking,
  getAgeOptions,
} from "../helper";
import RadioButton from "components/BaseWidgets/radioButton";
import "./style.scss";
import {
  useCommunities,
  useIncomes,
  useProfession,
  useSelectOptions,
} from "hooks/api/useListing";
import { mapToSelectOptions } from "utils/formatHelper";
import AlertNotification from "components/CustomWidgets/alertNotification";
import { retrieveToken } from "utils/storage";
import { useEffect, useState } from "react";
import { useStates, useDistrict, useTown } from "hooks/api/useListing";

function PartnerPreferences({ form }) {
  const {
    maritalStatus,
    diet,
    familyType,
    complexion,
    religion,
    nationality,
    qualification,
    familyStatus,
  } = useSelectOptions({
    screenTypes: [
      "familyType",
      "familyStatus",
      "diet",
      "complexion",
      "qualification",
      "maritalStatus",
    ],
  });

  const userGender = JSON.parse(retrieveToken("user"));
  const selectAge = getAgeOptions(userGender?.gender);

  const ageRange = Form.useWatch("AgeRange", form);
  const heightRange = Form.useWatch("BodyHeightRange", form);
  const weightRange = Form.useWatch("BodyWeightRange", form);
  const userReligion = Form.useWatch("userReligion", form);

  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [minHeight, setMinHeight] = useState(100);
  const [maxHeight, setMaxHeight] = useState(230);
  const [minWeight, setMinWeight] = useState(30);
  const [maxWeight, setMaxWeight] = useState(150);

  useEffect(() => {
    if (Array.isArray(ageRange) && ageRange.length === 2) {
      setMinAge(ageRange[0]);
      setMaxAge(ageRange[1]);
    }
  }, [ageRange]);

  useEffect(() => {
    if (heightRange && Array.isArray(heightRange)) {
      setMinHeight(heightRange[0] || 100);
      setMaxHeight(heightRange[1] || 230);
    }
  }, [heightRange]);

  useEffect(() => {
    if (weightRange && Array.isArray(weightRange)) {
      setMinWeight(weightRange[0] || 30);
      setMaxWeight(weightRange[1] || 150);
    }
  }, [weightRange]);

  const { data: professionData, isLoading: isProfessionPending } =
    useProfession({
      search: "",
      screen: 1,
    });
  const selectProfession = mapToSelectOptions(professionData);

  const { data: communityData, isLoading: isCommunityPending } = useCommunities(
    {
      search: "",
      parent_id: Form.useWatch("religion", form),
      screen: 1,
    },
  );
  const selectCommunity = mapToSelectOptions(communityData);

  const { data: incomeData, isLoading: isIncomePending } = useIncomes({
    search: "",
    screen: 1,
  });
  const selectAnnualIncome = mapToSelectOptions(incomeData);

  const { data: stateData, isLoading: isStatePending } = useStates({
    search: "",
    country_id: Form.useWatch("country", form),
  });
  const selectStates = mapToSelectOptions(stateData);

  const { data: districtData, isLoading: isDistrictPending } = useDistrict({
    search: "",
    parent_id: Form.useWatch("city", form),
  });
  const selectDistricts = mapToSelectOptions(districtData);

  // const ageRange = Form.useWatch("AgeRange", form);
  // const heightRange = Form.useWatch("BodyHeightRange", form);
  // const weightRange = Form.useWatch("BodyWeightRange", form);
  // const userReligion = Form.useWatch("userReligion", form);

  useEffect(() => {
    if (!form.getFieldValue("BodyHeightRange")) {
      form.setFieldsValue({
        BodyHeightRange: [100, 230],
        height: "100 cm-230 cm",
      });
    }

    if (!form.getFieldValue("BodyWeightRange")) {
      form.setFieldsValue({
        BodyWeightRange: [30, 150],
        weight: "30 Kg-150 Kg",
      });
    }
  }, [form]);

  useEffect(() => {
    if (nationality?.options?.length) {
      const indiaOption = nationality.options.find(
        (opt) => opt.label === "India" || opt.name === "India",
      );
      if (indiaOption) {
        const currentValue = form.getFieldValue("country");
        if (!currentValue || currentValue.length === 0) {
          form.setFieldsValue({
            country: [indiaOption.value || indiaOption.id],
          });
        }
      }
    }
  }, [nationality?.options, form]);

  useEffect(() => {
    const fieldsWithAny = [
      { name: "qualification", options: qualification?.options },
      { name: "occupation", options: selectProfession },
      { name: "marital_status", options: maritalStatus?.options },
      { name: "annual_income", options: selectAnnualIncome },
      { name: "complexion", options: complexion?.options },
      { name: "diet", options: diet?.options },
      { name: "family_type", options: familyType?.options },
      { name: "family_status", options: familyStatus?.options },
      { name: "community", options: selectCommunity },
    ];

    fieldsWithAny.forEach((field) => {
      if (field.options?.length) {
        const anyOption = field.options.find((opt) => opt.label === "Any");
        if (anyOption) {
          const currentValue = form.getFieldValue(field.name);
          if (!currentValue || currentValue.length === 0) {
            form.setFieldsValue({
              [field.name]: [anyOption.value],
            });
          }
        }
      }
    });
  }, [
    qualification?.options,
    selectProfession,
    maritalStatus?.options,
    selectAnnualIncome,
    complexion?.options,
    diet?.options,
    familyType?.options,
    familyStatus?.options,
    selectCommunity,
    form,
  ]);

  return (
    <div className="about-bride-wrapper partner-preferences-wrapper  flex flex-col items-center w-full">
      <div className="heading-wrapper w-full flex flex-col gap-2 mb-8">
        <p className="title font-title-xl">Partner preferences</p>
        <p className="sub-text font-body-md2">
          Select preferences for the ideal partner.
        </p>
      </div>
      <div className="basic-info-wrapper w-full mb-6">
        <div className="bride-form-container">
          <Form
            form={form}
            className="basic-form"
            layout="vertical"
            initialValues={{
              drink: 2,
              smoke: 2,
              BodyHeightRange: [100, 230],
              height: "100-230",
              BodyWeightRange: [30, 150],
              weight: "30-150",
              AgeRange: [],
              age: "",
            }}
          >
            <Form.Item
              name="AgeRange"
              className="form-item m-0"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || !value[0] || !value[1]) {
                      return Promise.reject("Please select age range");
                    }
                    if (parseInt(value[0]) > parseInt(value[1])) {
                      return Promise.reject(
                        "Min age cannot be greater than max age",
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <div className="age-range-wrapper range-preferences gap-4">
                <Select
                  value={minAge || undefined}
                  showSearch
                  widthVariant="wFull"
                  placeholder="Select"
                  labelClassName="label"
                  inputClassName="select-dropdown"
                  label="Age"
                  options={selectAge.map((opt) => ({
                    ...opt,
                    disabled: maxAge
                      ? parseInt(opt.value) >= parseInt(maxAge)
                      : false,
                  }))}
                  onChange={(val) => {
                    setMinAge(val);
                    const updated = [val, maxAge];
                    form.setFieldsValue({ AgeRange: updated });

                    if (updated[0] && updated[1]) {
                      form.setFieldsValue({
                        age: `${updated[0]}-${updated[1]}`,
                      });
                    }
                  }}
                />
                <label className="to-label">to</label>
                <Select
                  value={maxAge || undefined}
                  showSearch
                  widthVariant="wFull"
                  placeholder="Select"
                  labelClassName="label"
                  inputClassName="select-dropdown"
                  options={selectAge.map((opt) => ({
                    ...opt,
                    disabled: minAge
                      ? parseInt(opt.value) <= parseInt(minAge)
                      : false,
                  }))}
                  onChange={(val) => {
                    setMaxAge(val);
                    const updated = [minAge, val];
                    form.setFieldsValue({ AgeRange: updated });

                    if (updated[0] && updated[1]) {
                      form.setFieldsValue({
                        age: `${updated[0]}-${updated[1]}`,
                      });
                    }
                  }}
                />
              </div>
            </Form.Item>

            <Form.Item name="age" hidden>
              <input type="hidden" />
            </Form.Item>

            <Form.Item name="userReligion" hidden>
              <input type="hidden" />
            </Form.Item>

            <Form.Item
              name="religion"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your religion",
                },
              ]}
            >
              <Select
                isDisabled
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Religion"
                options={religion?.options}
                isLoading={religion?.isLoading}
                onChange={(value) => {
                  if (value !== userReligion) {
                    AlertNotification(
                      "warning",
                      "You have selected a different religion than yours",
                    );
                  }

                  form.setFieldsValue({
                    religion: value,
                    community: [],
                  });
                }}
              />
            </Form.Item>

            <Form.Item
              name="community"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your community",
                },
              ]}
            >
              <Select
                isDisabled={!Form.useWatch("religion", form)}
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Community"
                options={selectCommunity}
                isLoading={isCommunityPending}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="country"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your nationality",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Nationality"
                options={nationality?.options}
                isLoading={nationality?.isLoading}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="city"
              className="form-item m-0 profession-area"
              rules={[{ required: true, message: "Please select your State" }]}
            >
              <Select
                isDisabled={!Form.useWatch("country", form)?.length}
                widthVariant="wFull"
                placeholder="Select"
                labelClassName="label"
                inputClassName="select-dropdown"
                label="State"
                options={selectStates}
                isLoading={isStatePending}
                mode="multiple"
                onChange={() => {
                  form.setFieldsValue({ place: [] });
                }}
              />
            </Form.Item>

            <Form.Item
              name="place"
              className="form-item m-0 profession-area"
              rules={[
                { required: true, message: "Please select your District" },
              ]}
            >
              <Select
                isDisabled={!Form.useWatch("city", form)?.length}
                widthVariant="wFull"
                placeholder="Select"
                labelClassName="label"
                inputClassName="select-dropdown"
                label="District"
                options={selectDistricts}
                isLoading={isDistrictPending}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="qualification"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your qualification",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Qualification"
                options={qualification.options}
                isLoading={qualification.isLoading}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="occupation"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your profession",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Profession"
                options={selectProfession}
                isLoading={isProfessionPending}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="marital_status"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your marital status",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Marital status"
                options={maritalStatus?.options}
                isLoading={maritalStatus?.isLoading}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="annual_income"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your annual income",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Annual income"
                options={selectAnnualIncome}
                isLoading={isIncomePending}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="complexion"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your complexion",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Complexion"
                options={complexion?.options}
                isLoading={complexion?.isLoading}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="diet"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your diet",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Diet"
                options={diet?.options}
                isLoading={diet?.isLoading}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="family_type"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your family type",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Family type"
                options={familyType?.options}
                isLoading={familyType?.isLoading}
                mode="multiple"
              />
            </Form.Item>

            <Form.Item
              name="family_status"
              className="form-item m-0 profession-area"
              rules={[
                {
                  required: true,
                  message: "Please select your family status",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Family status"
                options={familyStatus?.options}
                isLoading={familyStatus?.isLoading}
                mode="multiple"
              />
            </Form.Item>

            {/* Height Range */}
            <Form.Item
              name="BodyHeightRange"
              className="m-0"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || !value[0] || !value[1]) {
                      return Promise.reject("Please select height range");
                    }
                    if (parseInt(value[0]) > parseInt(value[1])) {
                      return Promise.reject(
                        "Min height cannot be greater than max height",
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <div className="height-range-wrapper range-preferences gap-4">
                {/* Min Height */}
                <Select
                  value={minHeight || undefined}
                  showSearch
                  widthVariant="wFull"
                  placeholder="Select"
                  labelClassName="label"
                  inputClassName="select-dropdown"
                  label="Body height"
                  options={selectBodyHeight.map((opt) => ({
                    ...opt,
                    disabled: maxHeight ? opt.value >= maxHeight : false,
                  }))}
                  onChange={(val) => {
                    setMinHeight(val);
                    const updated = [val, maxHeight];
                    form.setFieldsValue({ BodyHeightRange: updated });

                    if (updated[0] && updated[1]) {
                      const heightString = `${updated[0]} cm-${updated[1]} cm`;
                      form.setFieldsValue({ height: heightString });
                    }

                    form.validateFields(["BodyHeightRange"]);
                  }}
                />

                <label className="to-label">to</label>

                {/* Max Height */}
                <Select
                  value={maxHeight || undefined}
                  showSearch
                  widthVariant="wFull"
                  placeholder="Select"
                  labelClassName="label"
                  inputClassName="select-dropdown"
                  options={selectBodyHeight.map((opt) => ({
                    ...opt,
                    disabled: minHeight ? opt.value <= minHeight : false,
                  }))}
                  onChange={(val) => {
                    setMaxHeight(val);
                    const updated = [minHeight, val];
                    form.setFieldsValue({ BodyHeightRange: updated });

                    if (updated[0] && updated[1]) {
                      const heightString = `${updated[0]} cm-${updated[1]} cm`;
                      form.setFieldsValue({ height: heightString });
                    }

                    form.validateFields(["BodyHeightRange"]);
                  }}
                />
              </div>
            </Form.Item>

            <Form.Item name="height" hidden>
              <input type="hidden" />
            </Form.Item>

            {/* Weight Range */}
            <Form.Item
              name="BodyWeightRange"
              className="m-0"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value || !value[0] || !value[1]) {
                      return Promise.reject("Please select weight range");
                    }
                    if (parseInt(value[0]) > parseInt(value[1])) {
                      return Promise.reject(
                        "Min weight cannot be greater than max weight",
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <div className="weight-range-wrapper range-preferences gap-4">
                {/* Min Weight */}
                <Select
                  value={minWeight || undefined}
                  showSearch
                  widthVariant="wFull"
                  placeholder="Select"
                  labelClassName="label"
                  inputClassName="select-dropdown"
                  label="Body weight"
                  options={selectBodyWeight.map((opt) => ({
                    ...opt,
                    disabled: maxWeight ? opt.value >= maxWeight : false,
                  }))}
                  onChange={(val) => {
                    setMinWeight(val);
                    const updated = [val, maxWeight];
                    form.setFieldsValue({ BodyWeightRange: updated });

                    if (updated[0] && updated[1]) {
                      const weightString = `${updated[0]} Kg-${updated[1]} Kg`;
                      form.setFieldsValue({ weight: weightString });
                    }

                    form.validateFields(["BodyWeightRange"]);
                  }}
                />

                <label className="to-label">to</label>

                {/* Max Weight */}
                <Select
                  value={maxWeight || undefined}
                  showSearch
                  widthVariant="wFull"
                  placeholder="Select"
                  labelClassName="label"
                  inputClassName="select-dropdown"
                  options={selectBodyWeight.map((opt) => ({
                    ...opt,
                    disabled: minWeight ? opt.value <= minWeight : false,
                  }))}
                  onChange={(val) => {
                    setMaxWeight(val);
                    const updated = [minWeight, val];
                    form.setFieldsValue({ BodyWeightRange: updated });

                    if (updated[0] && updated[1]) {
                      const weightString = `${updated[0]} Kg-${updated[1]} Kg`;
                      form.setFieldsValue({ weight: weightString });
                    }

                    form.validateFields(["BodyWeightRange"]);
                  }}
                />
              </div>
            </Form.Item>

            <Form.Item name="weight" noStyle>
              <input type="hidden" />
            </Form.Item>

            {/* Drinking & Smoking */}
            <div className="radio-button-wrapper w-full flex flex-col">
              <div className="radio-button-container flex flex-col gap-3">
                <label className="input-label">Drinking</label>
                <Form.Item
                  name="drink"
                  rules={[
                    {
                      required: true,
                      message: "Please select an option for drink",
                    },
                  ]}
                >
                  <RadioButton
                    className="radio-button-label"
                    radioGroupClass="radio-group"
                    options={drinking}
                    variant="secondary"
                  />
                </Form.Item>
              </div>

              <div className="radio-button-container flex flex-col gap-3">
                <label className="input-label">Smoking</label>
                <Form.Item
                  name="smoke"
                  rules={[
                    {
                      required: true,
                      message: "Please select an option for smoke",
                    },
                  ]}
                >
                  <RadioButton
                    className="radio-button-label"
                    radioGroupClass="radio-group"
                    options={smoking}
                    variant="secondary"
                  />
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default PartnerPreferences;
